<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <div class="fsa">
        <div>报价单（{{ table.total }}）</div>
        <el-button
          type="primary"
          icon="el-icon-folder-add"
          size="mini"
          @click="handleImport"
          >导入询价表</el-button
        >
      </div>
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="客户名称" prop="merchant_id">
          <el-select
            v-model="table.params.merchant_id"
            filterable
            placeholder="请选择"
            id="group_id"
            clearable
            @change="onSearch"
          >
            <el-option
              v-for="item in merchantArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分组名称" prop="group_id">
          <el-select
            v-model="table.params.group_id"
            filterable
            id="group_id"
            clearable
            @change="onSearch"
          >
            <el-option
              v-for="item in clientGroupArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="goods_name">
          <el-input
            size="mini"
            v-model.trim="table.params.goods_name"
            placeholder="请输入"
            clearable
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="定价周期" prop="date">
          <el-date-picker
            v-model="table.params.date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            id="date"
            class="selDaterangeWidth"
            @change="onSearch"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh-right" @click="reset2"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="bod">
      <!-- <div class="bodf" v-for="item in table.data" :key="item.id" @click="showDetail({...item, goods_name:table.params.goods_name})">
        <div class="bt">
          分组名称：<span class="gfr">{{ item.group_name }}</span>
        </div>
        <el-descriptions title="" direction="vertical" :column="5" border>
          <el-descriptions-item label="包含客户">{{
            item.mechant.join(",")
          }}</el-descriptions-item>
          <el-descriptions-item label="报价数">{{
            item.goods_count
          }}</el-descriptions-item>
          <el-descriptions-item label="定价周期"
            >{{ item.start_time }} 至 {{ item.end_time }}</el-descriptions-item
          >
          <el-descriptions-item label="备注">
            {{ item.desc }}
          </el-descriptions-item>
          <el-descriptions-item label="更新时间">{{
            item.update_time
          }}</el-descriptions-item>
        </el-descriptions>
      </div> -->
      <el-table :data="table.data" style="width: 100%" height="100%">
        <el-table-column prop="group_name" label="分组名称"> </el-table-column>
        <el-table-column prop="mechant" label="包含客户" width="150">
          <template v-slot="{ row }">
            <el-popover placement="right" width="400" trigger="click">
              <div>
                <div v-for="(item, i) in row.mechant" :key="i">
                  {{ i + 1 }}、{{ item }}
                </div>
              </div>
              <el-button type="text" slot="reference"
                >{{ row.mechant.length }}位</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="goods_count" label="商品项数" width="150">
        </el-table-column>
        <el-table-column prop="spec_count" label="报价数" width="150">
        </el-table-column>
        <el-table-column prop="start_time" label="定价周期" width="250">
          <template v-slot="{ row }">
            {{ row.start_time }}
            {{ row.start_time && row.end_time ? "至 " + row.end_time : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="desc" label="备注"> </el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="180">
          <template v-slot="{ row }">
            <div>{{ row.admin_name }}</div>
            {{ row.update_time }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template v-slot="{ row }">
            <el-button
              type="text"
              @click="
                showDetail({ ...row, goods_name: table.params.goods_name })
              "
              >查看</el-button
            >
            <el-button type="text" @click="add(row)">添加报价</el-button>
            <el-button type="text" @click="dow(row)">下载</el-button>
            <el-button
              class="delBtn"
              type="text"
              @click="del(row)"
              v-if="role_type == 1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination__wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="table.params.page"
        :page-size="table.params.count"
        :total="table.total"
        :page-sizes="[10, 20, 50, 100, 150, 300]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <!-- 导入商品，更新分组价 -->
    <el-dialog
      title="导入询价表"
      :visible.sync="dialogVisible"
      width="460px"
      :before-close="handleClose"
      top="5vh"
    >
      <el-form
        size="mini"
        :model="form"
        ref="elFormDom"
        :rules="form.rules"
        label-position="top"
      >
        <el-form-item>
          <el-button
            type="primary"
            plain
            @click="exportData('/admin/goods/downloadUpdate')"
            >下载询价样表</el-button
          >
        </el-form-item>
        <!-- 选客户名称，实际要传分组id给接口 -->
        <el-form-item label="客户分组" prop="group_id">
          <el-select v-model="form.group_id" filterable id="group_id">
            <el-option
              v-for="item in clientGroupArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">覆盖</el-radio>
            <el-radio :label="2">新增</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            drag
            :limit="1"
            action=""
            :headers="{ token: token }"
            :file-list="fileList"
            :on-remove="removeFile"
            :multiple="false"
            :http-request="httpRequestBack"
            accept=".xls,.xlsx"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="定价周期" prop="date">
          <el-date-picker
            v-model="form.date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input
            type="textarea"
            size="mini"
            v-model.trim="form.desc"
            placeholder="请输入"
            maxlength="100"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="uploadSubmit" :loading="form.loading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 导入异常弹窗 -->
    <el-dialog
      title="更新分组价反馈信息"
      :visible.sync="errorDialogVisible"
      width="500px"
      center
      :before-close="errorClose"
    >
      <div style="font-weight: bold">
        导入成功：{{ templateDialog.result }} 条
      </div>
      <div v-if="templateDialog.errors.length > 0" class="errorBox">
        <p v-for="(item, index) in templateDialog.errors" :key="index">
          {{ index + 1 }}、{{ item }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="errorExp">下载反馈信息</el-button>
        <el-button @click="errorClose">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 详情 -->
    <detail ref="detail" @refresh="getTable"></detail>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import Detail from "./components/Detail.vue";
import { getStorage } from "@/storage/index.js";
export default {
  name: "NormmIndex",
  components: {
    VTable,
    Detail,
  },
  mixins: [mixinTable],
  data() {
    return {
      role_type: getStorage("role_type"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      merchantArr: [], // 商家列表
      clientGroupArr: [], // 客户分组列表
      field: [
        { name: "name", label: "标准名称", hidden: false },
        { name: "goods_count", label: "关联商品数量", hidden: false },
        { name: "create_time", label: "创建时间", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "160",
          fixed: "right",
          hidden: false,
        },
      ],
      table: {
        loading: false,
        params: {
          goods_name: "",
          merchant_id: "",
          group_id: "",
          date: "",
          page: 1,
          count: 20,
        },
        data: [],
        total: 0,
      },
      form: {
        loading: false,
        file: "",
        group_id: "",
        type: 1,
        date: [],
        desc: "",
        rules: {
          group_id: [
            { required: true, message: "请选择客户分组", trigger: "change" },
          ],
        },
      },
      dialogVisible: false,
      fileList: [],
      // 导入后提示
      errorDialogVisible: false, // 导入异常弹窗
      templateDialog: {
        result: 0,
        errors: [],
      },
    };
  },
  created() {
    this.getTable();
    this.getMerchantSel();
    this.getClientGroup(); // 客户分组
  },
  methods: {
    add(row) {
      this.$refs.detail.getDetail1(row);
    },
    dow(row) {
      ///api/admin/goods/exportGroup?token=0964b53f6bc85163fb2fa3b361ced29e&status=1&good_name=&date=&publish_start=&publish_end=&cate_id=&order_cate_arr=&order_cate_id=&order_cate_tow=&group_id=&merchant_id=169&bind_id=&down_time=&down_time_start=&down_time_end=&norm_id=&is_norm=&is_image=&is_sold_out=&is_spec=&is_price=&is_top=&page=1&count=10
      // window.open(row.file);
      window.open(`${process.env.VUE_APP_BASE_API}/admin/goods/exportGroup?token=${this.token}&group_id=${row.group_id}`)
    },
    del(row) {
      this.$confirm("删除后客户将无法下单，确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http
            .post("/admin/group_file/deleteAll", { group_id: row.group_id })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("删除成功");
               this.getTable();
              }
            });
        })
        .catch(() => {});
    },
    handleImport(type) {
      this.dialogVisible = true;
    },
    getTable() {
      this.table.loading = true;
      let _params = { ...this.table.params };
      let _date = this.table.params.date;
      if (_date && _date.length > 0) {
        _params.start_time = _date[0];
        _params.end_time = _date[1];
      } else {
        _params.start_time = "";
        _params.end_time = "";
      }
      this.$http
        .get("/admin/group_file/list", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
    },
    httpRequestBack(file) {
      this.file = file.file;
    },
    // 导入
    uploadSubmit() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          if (!!this.file) {
            this.uploadRequer();
          } else {
            this.$message.warning("请选择要导入的文件");
          }
        }
      });
    },
    // 导入请求
    uploadRequer() {
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("type", this.form.type);
      formData.append("group_id", this.form.group_id);
      formData.append("desc", this.form.desc);
      if (this.form.date && this.form.date.length > 0) {
        formData.append("start_time", this.form.date[0]);
        formData.append("end_time", this.form.date[1]);
      }
      let apiUrl = "/admin/goods/importGroup";
      this.form.loading = true;
      this.$http
        .post(apiUrl, { formData, type: "upload" })
        .then((res) => {
          if (res.code == 1) {
            this.errorDialogVisible = true;
            if (res.data.errors || res.data.count) {
              this.templateDialog.errors = res.data.errors;
              this.templateDialog.result = res.data.count;
            }
          }
        })
        .finally(() => {
          this.form.loading = false;
          this.handleClose();
        });
    },
    errorExp() {
      const text = this.templateDialog.errors;
      const blob = new Blob([text], { type: "text/plain" });
      // 创建a标签元素
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "file.txt";
      // 添加到页面上进行点击下装
      document.body.appendChild(link);
      link.click();
      // 移除临时生成的a标签无素
      document.body.removeChild(link);
    },
    removeFile() {
      this.fileList = [];
    },
    // 关闭导入弹窗
    handleClose() {
      this.dialogVisible = false;
      this.fileList = [];
      this.file = "";
      this.form.group_id = "";
      this.form.type = 1;
      this.form.date = [];
      this.form.desc = "";
    },
    // 关闭异常
    errorClose() {
      this.errorDialogVisible = false;
      this.getTable();
    },
    // 详情
    showDetail(row) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
  },
};
</script>
<style scoped lang="scss">
.errorBox {
  max-height: 500px;
  overflow-y: scroll;
}
.fsa {
  display: flex;
  justify-content: space-between;
  padding: 0 0 10px;
}
.pagination__wrap {
  background: #fff;
  padding: 10px 60px;
  text-align: right;
  /* padding-right: 40px; */
}
.bod {
  flex: 1;
  background: #fff;
  padding: 0 24px;
}
.bt {
  background: #fff7ed;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid #e5e5e5;
  border-bottom: none;
  display: inline-block;
  padding: 5px 15px;
  font-size: 14px;
  color: #9b6624;
}
.gfr {
  text-decoration: underline;
}
.bodf {
  padding: 0 0 20px;
  cursor: pointer;
}
</style>
